export const FETCH_FOLDERS = 'folderActions/FETCH_FOLDERS';
export const FETCH_FOLDERS_SUCCESS = 'folderActions/FETCH_FOLDERS_SUCCESS';
export const FETCH_FOLDERS_FAILED = 'folderActions/FETCH_FOLDERS_FAILURE';

export const CREATE_FOLDER = 'folderActions/CREATE_FOLDER';
export const CREATE_FOLDER_SUCCESS = 'folderActions/CREATE_FOLDER_SUCCESS';
export const CREATE_FOLDER_FAILED = 'folderActions/CREATE_FOLDER_FAILURE';

export const FETCH_FOLDER = 'folderActions/FETCH_FOLDER';
export const FETCH_FOLDER_SUCCESS = 'folderActions/FETCH_FOLDER_SUCCESS';
export const FETCH_FOLDER_FAILED = 'folderActions/FETCH_FOLDER_FAILURE';

export const DELETE_FOLDER = 'folderActions/DELETE_FOLDER';
export const DELETE_FOLDER_SUCCESS = 'folderActions/DELETE_FOLDER_SUCCESS';
export const DELETE_FOLDER_FAILED = 'folderActions/DELETE_FOLDER_FAILURE';

export const UPDATE_FOLDER = 'folderActions/UPDATE_FOLDER';
export const UPDATE_FOLDER_SUCCESS = 'folderActions/UPDATE_FOLDER_SUCCESS';
export const UPDATE_FOLDER_FAILED = 'folderActions/UPDATE_FOLDER_FAILURE';

export const CHANGE_STATE = 'folderActions/CHANGE_STATE';

export function fetchFolders() {
  return {
    type: FETCH_FOLDERS,
  };
}

export function fetchFoldersSuccess(folders) {
  return {
    type: FETCH_FOLDERS_SUCCESS,
    folders,
  };
}

export function fetchFoldersFailed(err) {
  return {
    type: FETCH_FOLDERS_FAILED,
    err,
  };
}

export function createFolder(details) {
  return {
    type: CREATE_FOLDER,
    details,
  };
}

export function changeState() {
  return {
    type: CHANGE_STATE,
  };
}

export function createFolderSuccess(pageFolder) {
  return {
    type: CREATE_FOLDER_SUCCESS,
    pageFolder,
  };
}

export function createFolderFailed(error) {
  return {
    type: CREATE_FOLDER_FAILED,
    error,
  };
}

export function deleteFolder(pageId) {
  return {
    type: DELETE_FOLDER,
    pageId,
  };
}

export function deleteFolderSuccess(folder) {
  return {
    type: DELETE_FOLDER_SUCCESS,
    folder,
  };
}

export function deleteFolderFailed(err) {
  return {
    type: DELETE_FOLDER_FAILED,
    err,
  };
}

export function updateFolder(pageId, details) {
  return {
    type: UPDATE_FOLDER,
    pageId,
    details,
  };
}

export function updateFolderSuccess(folder) {
  return {
    type: UPDATE_FOLDER_SUCCESS,
    folder,
  };
}

export function updateFolderFailed(err) {
  return {
    type: UPDATE_FOLDER_FAILED,
    err,
  };
}

export function fetchFolder(pageId, subdomain) {
  return {
    type: FETCH_FOLDER,
    pageId,
    subdomain,
  };
}

export function fetchFolderSuccess(folder) {
  return {
    type: FETCH_FOLDER_SUCCESS,
    folder,
  };
}

export function fetchFolderFailed(err) {
  return {
    type: FETCH_FOLDER_FAILED,
    err,
  };
}
